// extracted by mini-css-extract-plugin
export var avatarContainer = "_6d-1";
export var largeAvatarContainer = "_6d-2";
export var smallAvatarContainer = "_6d-0";